import {Injectable} from '@angular/core';
import * as shajs from 'sha.js';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {

  public sanitizeEmail(email: string): string {
    return email.toLowerCase().trim();
  }

  public hashEmailAndPassword(email: string, password: string): string {
    return shajs('sha256').update(this.sanitizeEmail(email) + password).digest('hex');
  }

}
